namespace TabAurous.Common {
    export interface GetAPIKeyResponse extends Serenity.ServiceResponse {
        Token?: string;
    }
}
